import { Profile, ProfileStreamIQ } from '@/shared/store/useAppStore'

export const mapProfileStreamIQToProfile = (
    profileStreamIQ: ProfileStreamIQ
): Profile => ({
    iconId: profileStreamIQ.iconId,
    id: profileStreamIQ.id,
    isKid: !profileStreamIQ.isAdult,
    order: profileStreamIQ.order,
    profile_name: profileStreamIQ.name,
    version: profileStreamIQ.version,
    pin: profileStreamIQ.pin || 0,
})
